export function normalizeBarcodeInput(value: string) {
  return value.toUpperCase();
}

export function normalizeBarcodeInputElement(event: Event) {
  const input = event.target;

  if (!(input instanceof HTMLInputElement)) {
    return '';
  }

  const originalValue = input.value;
  const normalizedValue = normalizeBarcodeInput(originalValue);
  const selectionStart = input.selectionStart;
  const selectionEnd = input.selectionEnd;
  const selectionDirection = input.selectionDirection;

  if (originalValue !== normalizedValue) {
    input.value = normalizedValue;
  }

  if (selectionStart != null && selectionEnd != null) {
    const lengthDelta = normalizedValue.length - originalValue.length;
    input.setSelectionRange(selectionStart + lengthDelta, selectionEnd + lengthDelta, selectionDirection ?? undefined);
  }

  return normalizedValue;
}

export function trimBarcodeForRequest(value: string) {
  return value.trim();
}
